// 現在のURLから「どの画面か（admin / company / self）」を判定
const getPageType = (pathname = "", search = "", currentUser) => {
  if (pathname.startsWith("/company/members/")) return "management_company";
  if (pathname.startsWith("/company/candidates/")) return "recruit_company";
  if (pathname.startsWith("/user_show/")) return "admin";

  const isAdmin = currentUser?.admin_flag === true;
  const params = new URLSearchParams(search);
  const hasUserId = params.has("user_id");

  // user_id がある かつ admin_flag が true の場合のみ admin 扱い
  if (hasUserId && isAdmin) return "admin";

  return "self";
};

export default getPageType;
